export default __webpack_public_path__ + "static/1354-a570fe839063f3ea7df3fef606427c22.gif";